import { PDivider } from 'components/prime/PDivider/PDivider';
import styled from 'styled-components';

export const LeftPanelPageBreadCrumbsStyle = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 56px;
    overflow: hidden;
    span {
      cursor: auto;
    }
  `,
  Divider: styled(PDivider)`
    &.p-divider {
      margin: 0 20px;
    }
  `,
};
